export const pricingTable = [
  {
    email: 2500,
    pricing: "0.40",
    discount: {
      hasDiscount: true,
      amount: 500,
      pricing: "0.20"
    }
  },
  {
    email: 5000,
    pricing: "0.30",
    discount: {
      hasDiscount: true,
      amount: 500,
      pricing: "0.20"
    }
  },
  {
    email: 10000,
    pricing: "0.26",
    discount: {
      hasDiscount: true,
      amount: 600,
      pricing: "0.20"
    }
  },
  {
    email: 30000,
    pricing: "0.23"
  },
  {
    email: 50000,
    pricing: "0.20"
  },
  {
    email: 100000,
    pricing: "0.18"
  },
  {
    email: 200000,
    pricing: "0.16"
  },
  {
    email: 300000,
    pricing: "0.14"
  },
  {
    email: 500000,
    pricing: "0.10"
  },
  {
    email: 1000000,
    pricing: "0.09"
  }
];
